import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, Pagination } from "swiper";

type TimelineProps = ComponentProps & {
  fields: {
    childItems: any;
    titleSection: Field<string>;
  };
  locale: string;
  lang: string;
};

const Timeline = (props: TimelineProps): JSX.Element => (
  <>
  <div className="flex flex-col !my-12 responsive text-theme-color">
      <div className="py-20">
        <div className="text-center mb-24 overflow-hidden">
          <h2 className="text-3brand md:text-2brand font-medium animate-top-dga ">
            {props?.fields?.titleSection?.value}
          </h2>
        </div>
        <Swiper 
            // freeMode={true}
            // modules={[FreeMode]}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination, A11y]}
            a11y={{
              enabled: true,
              paginationBulletMessage: "Go to slide {{index}}",
            }}
            slidesPerView={2}
            breakpoints={{
              640: {
                slidesPerView: 2,
                centeredSlides: true
              },
              1024: {
                slidesPerView: 4,
                centeredSlides: false,
              },
            }}
            className={`timeline-swiper bg-career-gredient-theme-color
             min-h-full relative w-full first:!justify-around lg:timeline-swiper
             animate-right ${props?.locale == props?.lang? "rtl faded-gredient-left": "faded-gredient-right"}`}
          >
            {props?.fields?.childItems?.map((item: any, index: any) => {
            return (
              <SwiperSlide className="w-2/4 m-0 pb-20 pt-12 overflow-hidden" key={index}>
              <div className={` animate-top-dga  text-start flex flex-col w-full ${props?.locale == props?.lang? "rtl": ""}`}>
                <h3 className="text-4xl mb-4">{item?.fields?.Title?.value}</h3>
                <div className="flex items-center">
                  <div className="bg2-theme-color w-[20px] h-[20px]" />
                  <div className="bg2-theme-color w-full h-[2px]" />
                </div>
                <p className="py-8 w-2/3">
                {item?.fields?.Description?.value}
                </p>
              </div>
            </SwiperSlide>
            );
          })}
          </Swiper>
        </div>
    </div>
  </>
);

export default withDatasourceCheck()<TimelineProps>(Timeline);
